var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSparkle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5449 17.1387L11.6699 22.2266C11.6144 22.3761 11.5145 22.505 11.3836 22.5961C11.2526 22.6871 11.097 22.7359 10.9375 22.7359C10.778 22.7359 10.6223 22.6871 10.4914 22.5961C10.3605 22.505 10.2606 22.3761 10.2051 22.2266L8.33007 17.1387C8.2905 17.0313 8.22809 16.9337 8.14716 16.8528C8.06623 16.7719 7.96871 16.7095 7.86132 16.6699L2.77342 14.7949C2.62391 14.7394 2.49496 14.6395 2.4039 14.5086C2.31285 14.3776 2.26404 14.222 2.26404 14.0625C2.26404 13.903 2.31285 13.7473 2.4039 13.6164C2.49496 13.4855 2.62391 13.3856 2.77342 13.3301L7.86132 11.4551C7.96871 11.4155 8.06623 11.3531 8.14716 11.2722C8.22809 11.1912 8.2905 11.0937 8.33007 10.9863L10.2051 5.89842C10.2606 5.74891 10.3605 5.61996 10.4914 5.5289C10.6223 5.43785 10.778 5.38904 10.9375 5.38904C11.097 5.38904 11.2526 5.43785 11.3836 5.5289C11.5145 5.61996 11.6144 5.74891 11.6699 5.89842L13.5449 10.9863C13.5845 11.0937 13.6469 11.1912 13.7278 11.2722C13.8087 11.3531 13.9063 11.4155 14.0137 11.4551L19.1016 13.3301C19.2511 13.3856 19.38 13.4855 19.4711 13.6164C19.5621 13.7473 19.6109 13.903 19.6109 14.0625C19.6109 14.222 19.5621 14.3776 19.4711 14.5086C19.38 14.6395 19.2511 14.7394 19.1016 14.7949L14.0137 16.6699C13.9063 16.7095 13.8087 16.7719 13.7278 16.8528C13.6469 16.9337 13.5845 17.0313 13.5449 17.1387V17.1387Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 1.5625V6.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5312 3.90625H14.8438",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 7.03125V10.1562",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 8.59375H20.3125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.af701d26.svg";
export { ForwardRef as ReactComponent };